import styled from "styled-components";

import StyledPicker from "features/shared/components/picker/styles/StyledPicker.styled";
import StyledDatePicker from "features/shared/components/date-picker/styles/StyledDatePicker.styled";
import HaveDocumentQuestion from "../components/have-document-questions/styles/HaveDocumentQuestion.styled";
import { Radios } from "features/shared/components/radio-input/styles/Radios.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { QuestionBoxProps } from "./QuestionBox.styled";

// category titles earn their space only once the page offers this many options
const CATEGORY_TITLE_MIN_OPTIONS = 5;

const withCategoryTitle = ({ $optionsCount }: QuestionBoxProps) =>
  ($optionsCount ?? 0) >= CATEGORY_TITLE_MIN_OPTIONS;

const QuestionBox = styled.div<QuestionBoxProps>`
  padding-bottom: 25px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h5 {
    font-size: ${({ theme }) => theme.fonts.summary.fontSize};
    font-weight: 600;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  section ${HaveDocumentQuestion} {
    box-sizing: border-box;
    width: 100%;
  }

  ${Summary} {
    font-weight: 600;
    display: ${(props) => (withCategoryTitle(props) ? "block" : "none")};
  }

  & > ${Summary} + section {
    padding-top: ${(props) => (withCategoryTitle(props) ? "25px" : "0")};
  }

  ${StyledPicker},
  ${Radios},
    ${StyledDatePicker} {
    margin-top: 16px;
    max-width: 400px;
  }

  & > :not(:first-child) {
    padding-top: 25px;
  }

  border-bottom: 1px solid
    ${(props) =>
      withCategoryTitle(props) && props.theme.hasSeparatorsForQuestions
        ? props.theme.colors.base2
        : "transparent"};

  .subtitle {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.base4};
  }
`;

export default QuestionBox;
